const React = require('react');

const Content = require('../common/Content.jsx');
const Name = require('../utility/Name.jsx');
const Token = require('../utility/Token.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region TOTALS

function Totals(props) {
    const config = props.config || {};
    let blockProps = {};
    let formatProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Format) {
            formatProps = config.Config.Format;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
    }
    if (!props.builder && !includes.RetailTotal && !includes.ConsignmentTotal) {
        return null;
    }
    const data = props.data || {};
    let localization;
    if (data.Gallery) {
        localization = data.Gallery.Localization;
    }
    let label, styleValue, value;
    if (includes.ConsignmentTotal) {
        value = Utilities.Format.Currency.getDisplayString(data.TotalConsignment, formatProps.currencyFormatConsignment, localization);

        if (includes.RetailTotal) {
            label = Utilities.Format.Currency.getDisplayString(data.TotalRetail, formatProps.currencyFormatRetail, localization);
        }
    } else if (includes.RetailTotal) {
        styleValue = Utilities.Config.getStyle(data, blockProps, 'Label');
        value = Utilities.Format.Currency.getDisplayString(data.TotalRetail, formatProps.currencyFormatRetail, localization);
    }
    let description;
    if (includes.ConsignmentTotal || includes.RetailTotal) {
        const styleDescription = Utilities.Config.getStyle(data, blockProps, 'Description', { whiteSpace: 'pre-wrap' });
        if (blockProps.displayType == 'inline') {
            styleDescription.marginRight = blockProps.marginRightDescription;
        } else {
            styleDescription.marginRight = undefined;
        }
        description = <span style={styleDescription}>{blockProps.textDescription}</span>;
    }
    return (
        <Content.LabelValue
            {...props}
            description={description}
            label={label}
            renderPlaceholder={description == undefined}
            styleValue={styleValue}
            value={value} />
    );
}

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType(),
                    { display: 'Label Properties', id: 'descriptionProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({ name: 'Description' }, { value: 'Totals' }, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Retail Total Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, undefined, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Consignment Total Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, {})
                ]
            };
        },
        format: function () {
            return {
                expanded: false,
                label: 'Advanced',
                options: [
                    _TypeConfig.options.currency({ display: 'Retail Total Currency Format', name: 'Retail' }),
                    _TypeConfig.options.currency({ display: 'Consignment Total Currency Format', includeHelpText: false, name: 'Consignment' })
                ]
            };
        },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Retail Total', name: 'RetailTotal', type: 'checkbox', value: true },
                    { display: 'Consignment Total', name: 'ConsignmentTotal', type: 'checkbox', value: true }
                ]
            };
        },
        style: function () { return _TypeConfig.panel.layoutStyle({}, { visible: function (config) { return config.Block && config.Block.displayType != 'columns'; } }); }
    }
};

// #endregion TOTALS

// #region TOTALS V2

function __TotalsV2(props) { return <Content.LabelValue {...props} collapseLabelIfEmpty={true} collapseValueIfEmpty={true} formatValue={false} value={props.content} /> }
const _TotalsV2 = Content.withLabelTokenParsing(__TotalsV2, (props, keyword, options) => {
    const data = props.data || {};
    const visibility = props.visibility || {};
    if (!props.builder && visibility[keyword] == false) {
        return '';
    }
    let replaceString = '';
    switch (keyword) {
        case Token.Total.Consignment:
            if (data.TotalConsignment != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.TotalConsignment, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        case Token.Total.Retail:
            if (data.TotalRetail != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.TotalRetail, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
}, { allowEmptyContent: true });
function TotalsV2(props) {
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    return <_TotalsV2 {...props} allowEmptyValue={true} visibility={props.config && props.config.config && props.config.config.Visibility} visibilityHash={visibilityHash} />
}
const TokensTotals = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Consignment Total', defaultValue, Token.Total.Consignment),
        Token.getCurrencyTokenConfig('Retail Total', defaultValue, Token.Total.Retail)
    ]
};
const TypeConfigTotalsV2 = {
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block(3),
        description: () => Content.TypeConfig.labelValue.panelV2.description(Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: 'Totals' })),
        label: (data) => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: `{${Token.Total.Retail}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Retail })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Consignment}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Consignment })),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Retail Total', name: Token.Total.Retail, type: 'checkbox', value: true, configurableDuringExport: (_, config, blockType) => Token.isTokenPresent(Token.Total.Retail, { ...config, type: blockType }, Name.Block.Consignment.Totals) },
                    { display: 'Consignment Total', name: Token.Total.Consignment, type: 'checkbox', value: true, configurableDuringExport: (_, config, blockType) => Token.isTokenPresent(Token.Total.Consignment, { ...config, type: blockType }, Name.Block.Consignment.Totals) }
                ],
                visible: () => false
            };
        }
    }
};

// #endregion TOTALS V2

module.exports = {
    Component: Totals,
    TypeConfig,

    V2: {
        Component: TotalsV2,
        Tokens: TokensTotals,
        TypeConfig: TypeConfigTotalsV2
    }
};